import { FormSectionGroup } from '@vwfs-bronson/bronson-react';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AddressFormNew } from '../../../../components/AddressFormNew';
import { BankDetailsNew } from '../../../../components/BankDetailsNew';
import { ContactDetailsFormNew } from '../../../../components/ContactDetailsFormNew';
import { PersonalDetailsFormNew } from '../../../../components/PersonalDetailsFormNew';
import { TradingDetailsServicePlanBusinessFormNew } from '../../../../components/TradingDetailsServicePlanBusinessFormNew';
import { journeyDataSelectors } from '../../../../services/redux/features/journeyData.slice';
import { useFormSectionHelpers } from '../../../utils';

const orderedForms = [
  'partnershipDetails',
  'contactAddress',
  'contactDetails',
  'partnershipBankAccountDetails',
  'partner1Details',
  'partner2Details',
] as const;
type FormId = (typeof orderedForms)[number];

export const CustomerDataServicePlanBusinessOther = () => {
  const [forms, setForms] = useState<FormId[]>([...orderedForms]);
  const [isFirstPersonAdded] = useState(false);
  const [isSecondPersonAdded] = useState(false);

  // When in Standalone Service Plan user selected Upfront payment for service plan,
  // then we do not need Bank Details
  const isUpfrontPayment = useSelector(journeyDataSelectors.isUpfrontPayment);

  useEffect(() => {
    const sections = [
      'partnershipDetails',
      'contactAddress',
      'contactDetails',
      ...(isUpfrontPayment ? [] : (['partnershipBankAccountDetails'] satisfies FormId[])),
      ...(isFirstPersonAdded ? (['partner1Details'] satisfies FormId[]) : []),
      ...(isSecondPersonAdded ? (['partner2Details'] satisfies FormId[]) : []),
    ] as FormId[];

    setForms(sections);
  }, [isUpfrontPayment, isFirstPersonAdded, isSecondPersonAdded]);

  const getFormHelpers = useFormSectionHelpers(forms);

  return (
    <>
      <FormSectionGroup>
        <TradingDetailsServicePlanBusinessFormNew.SPB
          formHelpers={getFormHelpers('partnershipDetails')}
          titleTranslationKey="tradingDetailsServicePlanBusinessForm:title:other"
        />
        <AddressFormNew.SPB formHelpers={getFormHelpers('contactAddress')} />
        <ContactDetailsFormNew.SPB formHelpers={getFormHelpers('contactDetails')} />
        {!isUpfrontPayment && (
          <BankDetailsNew.SPB
            formHelpers={getFormHelpers('partnershipBankAccountDetails')}
            titleTranslationKey="bankDetailsForm:title:business"
          />
        )}

        {/* Feature hidden in PC-3382 */}
        {/* <Layout className="u-mb">
          <Layout.Item>
            <Button
              icon={isFirstPersonAdded ? 'semantic-minus' : 'semantic-plus'}
              link
              secondary
              onClick={() => actions.customerDataServicePlanBusinessOther.setIsFirstPersonAdded(!isFirstPersonAdded)}
            >
              {isFirstPersonAdded
                ? t('customerDataServicePlanBusinessOther:removePartner1')
                : t('customerDataServicePlanBusinessOther:addPartner1')}
            </Button>
          </Layout.Item>
        </Layout> */}

        {isFirstPersonAdded && (
          <PersonalDetailsFormNew.SPB
            formHelpers={getFormHelpers('partner1Details')}
            titleTranslationKey="personalDetailsForm:title:other1"
          />
        )}

        {/* Feature hidden in PC-3382 */}
        {/* <Layout className="u-mb">
          <Layout.Item>
            <Button
              icon={isSecondPersonAdded ? 'semantic-minus' : 'semantic-plus'}
              link
              secondary
              onClick={() => actions.customerDataServicePlanBusinessOther.setIsSecondPersonAdded(!isSecondPersonAdded)}
            >
              {isSecondPersonAdded
                ? t('customerDataServicePlanBusinessOther:removePartner2')
                : t('customerDataServicePlanBusinessOther:addPartner2')}
            </Button>
          </Layout.Item>
        </Layout> */}

        {isSecondPersonAdded && (
          <PersonalDetailsFormNew.SPB
            formHelpers={getFormHelpers('partner2Details')}
            titleTranslationKey="personalDetailsForm:title:other2"
          />
        )}
      </FormSectionGroup>
    </>
  );
};
